// extracted by mini-css-extract-plugin
export default {"skeleton":"tableLoader_skeleton__H5DMp","loading":"tableLoader_loading__BkA1X"};